<template>

  <div class="product-features">
    <div class="details-details" v-for="(highlight, index) in highlights" :key="highlight"><ProductViewDetailsHighlights :highlight="highlight" :index="index+1"/></div>
    <div class="details-technology" :key="technologie.name" v-for="technologie in technologien"><ProductViewDetailsTechnologien :technologie="technologie"/></div>
  </div>

</template>

<script>
    import {computed} from "vue";
    import ProductViewDetailsTechnologien from "~/components/ProductViewDetailsTechnologien.vue";
    import ProductViewDetailsHighlights from "~/components/ProductViewDetailsHighlights.vue";
    import {useProductStore} from "~/store/productstore";


    export default {
        name: "ProductHighlightsAndTechnologien",
        components: {
          ProductViewDetailsTechnologien,
          ProductViewDetailsHighlights
        },
        setup() {
          const productstore = useProductStore();

          return {
            highlights: computed(() => productstore.getHighlights),
            technologien: computed(() => productstore.getTechnologien),
          }
        }
    }
</script>

<style lang="scss" scoped>

.product-features {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 80px;

  .details-details {
    width: 25%;
    padding: 0 30px;
    margin-bottom: 40px;

    @media (max-width: 740px) {
      width: 33.333333%;
    }

    @media (max-width: 540px) {
      width: 50%;
    }
  }
}
</style>
